"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFIDIcon = void 0;
const React = __importStar(require("react"));
const nfid_logo_svg_1 = __importDefault(require("src/hello_assets/src/components/ui/anonymous/assets/nfid_logo.svg"));
const NFIDIcon = () => {
    return React.createElement("span", { style: { width: 100, height: 100, borderRadius: 100, backgroundColor: "white", display: "inline-block" } },
        React.createElement("img", { src: nfid_logo_svg_1.default, style: { width: 80, height: 80, paddingTop: 20 }, alt: "" }));
};
exports.NFIDIcon = NFIDIcon;
